import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Button, { ButtonTheme } from 'builder/components/Button'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${Media.Phone`
    gap: 24px;
  `}
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;

  ${Media.Phone`
    flex-direction: column;
    gap: 12px;
  `}
`

export const Header = styled.h2`
  ${Typography.M}
  ${FontWeights.Medium}

  color: ${Colors.Neutral90};
`

export const Info = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral50};
`

export const ProfileLink = styled(Link)`
  ${Typography.Body}
  ${FontWeights.Medium}

  cursor: pointer;
  color: ${Colors.Blue50};
`

export const Description = styled.div`
  a {
    color: ${Colors.Blue50};
    font-weight: 500;
  }
  display: flex;
  color: ${Colors.Neutral50};
  ${Typography.Body}
  margin-top:  ${Spacing.S};
`

export const ContentWrapper = styled.div`
  position: relative;
`

export const NoResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.White};
  padding: 48px 0px;
  text-align: center;

  ${Media.Phone`
    padding: 32px 0;
  `}
`

export const CardsList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  ${Media.Tablet`
    grid-template-columns: repeat(1, minmax(0, 1fr));
  `}

  ${Media.Phone`
    gap: 12px;
  `}
`

export const ActionContainer = styled.div`
  display: flex;
  justify-content: center;

  ${Media.Phone`
    width: 100%;
  `}
`

export const ActionButton = styled(Button).attrs({ theme: ButtonTheme.default })`
  display: block;
  width: auto;
  margin: auto;
  padding: 16px 24px;
  color: ${Colors.Neutral50};
  background-color: ${Colors.Neutral5};
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: color 0.15s;

  &:hover {
    color: ${Colors.Blue50};
    background-color: ${Colors.Blue10};
  }

  ${Media.Phone`
    width: 100%;
    margin-top: -12px;
  `}
`
